<template>
    <div class="card">
        <div class="card-header card-i">
            <h6 class="m-0 font-weight-bold text-primary">Cadastro de clientes
                <select class="form-control select-graph" v-model="year" @change="changeYearFilter">
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                </select>
            </h6>
        </div>
        <div class="card-body card-body-no-spaccing">
             <Line :data="chartData" :options="chartOptions" :style="style" />
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js'
import { Line } from 'vue-chartjs'
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const year = ref('2026');


const chartData = ref({
    labels: [],
    datasets: []
});

const chartOptions = ref({
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        x: {
            display: true, // Hides the x-axis labels and grid lines
        },
        y: {
            display: true, // Hides the y-axis labels and grid lines
        },
    }


});

const style = ref({
    height: '300px', // Set your desired height here
    width: '100%',
    position: 'relative',
});

const changeYearFilter = () => {
    loadData();
};


onMounted(async () => {
    loadData();
});

const loadData = async () => {
    try {
        const response = await api.get('/dashboard/historyClients', { params: { 'year': year.value } }).then((response) => { return response; }).catch((error) => { handleRequestErrors(error.status) });
        const apiData = response.data;
        chartData.value = {
            labels: apiData.labels,
            datasets: [
                {
                    label: 'Ativos',
                    borderColor: 'rgba(1,97,38, 0.8)',
                    borderWidth: 2,
                    tension: 0.1,
                    backgroundColor: 'rgba(1,97,38, 0.3)',
                    data: apiData.active
                },
                {
                    label: 'Baixados',
                    borderColor: 'rgba(128,3,3, 0.8)',
                    borderWidth: 2,
                    tension: 0.1,
                    backgroundColor: 'rgba(128,3,3, 0.3)',
                    data: apiData.downloaded
                }
            ]
        };
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}


</script>